import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
/** The company behind StagVista. Change these here and every "A product of" line follows. */
export const COMPANY = {
    name: "Steeviz LTD",
    url: "https://www.steeviz.com/",
    /** Where customers are pointed when something keeps going wrong. */
    supportEmail: "support@stagvista.com",
};
/**
 * The quiet "A product of Steeviz LTD" line used on signed-out screens, About and footers.
 * The company name links to the company site in a new tab (`rel="noopener noreferrer"`).
 * Inside the desktop app's webview a plain `target="_blank"` link may not open, so
 * callers there pass `onOpenLink`.
 */
export function CompanyCredit({ withCopyright = false, onOpenLink, className, children: _children, ...props }) {
    return (_jsxs("p", { className: cn("text-caption text-fg-tertiary", className), ...props, children: [withCopyright ? `© ${new Date().getFullYear()} ` : null, "A product of", " ", _jsx("a", { href: COMPANY.url, target: "_blank", rel: "noopener noreferrer", onClick: onOpenLink
                    ? (event) => {
                        event.preventDefault();
                        onOpenLink(COMPANY.url);
                    }
                    : undefined, className: "underline hover:text-fg-primary", children: COMPANY.name })] }));
}
//# sourceMappingURL=company-credit.js.map